import { defineStore } from "pinia";
import _ from "lodash";
import {
    NotificationState,
    NotificationType,
    NotificationError
} from "@/shared/types";
import {
    Environment,
    getEnvironment
} from "@/shared/env";

class NotificationImpl {
    constructor (readonly message: string, readonly type: NotificationType) {
    }
}

export const initialState: NotificationState = {
    notifications: [],
};

export const useNotifierStore = defineStore("notifier", {
    state: (): NotificationState => (_.cloneDeep(initialState)),
    actions: {
        clearAlerts () {
            this.notifications = [];
        },
        clear (index) {
            this.notifications.splice(index, 1);
        },
        setDanger (message) {
            if (!message || getEnvironment() === Environment.Demo) return;
            this.notifications.push(new NotificationImpl(message, NotificationType.Danger));
        },
        setInfo (message) {
            if (!message) return;
            this.notifications.push(new NotificationImpl(message, NotificationType.Info));
        },
        setSuccess (message) {
            if (!message) return;
            this.notifications.push(new NotificationImpl(message, NotificationType.Success));
        },
        setWarning (message) {
            if (!message) return;
            this.notifications.push(new NotificationImpl(message, NotificationType.Warning));
        },
        error (errorObj: NotificationError): Promise<any> {
            return new Promise<any>((resolve, reject) => {
                let error = errorObj.error;
                if (typeof error === "string") {
                    this.setDanger(error);

                    if (errorObj.rethrow) {
                        reject(error);
                    }

                    return;
                }

                const baseErrorMessage = "Error processing your request. Please try again later.";

                if (!error) {
                    this.setDanger(baseErrorMessage);

                    if (errorObj.rethrow) {
                        reject(baseErrorMessage);
                    }

                    return;
                }

                if (error.payload) {
                    error = error.payload;
                }

                if (error.response) {
                    error = error.response;
                }

                if (error.data) {
                    error = error.data;
                }

                let message = baseErrorMessage;
                if (error.errorMessage) {
                    message = error.errorMessage;
                } else if (error.value && error.value.errorMessage) {
                    message = error.value.errorMessage;
                } else if (error.message) {
                    message = error.message;
                } else if (Array.isArray(error[Object.keys(error)[0]])) {
                    message = "";
                    Object.keys(error).forEach(i => {
                        error[i].forEach((m: string) => {
                            message += m + "<br/>";
                        });
                    });
                    message = message.slice(0, -5);
                }

                this.setDanger(message);

                if (errorObj.rethrow) {
                    reject(message);
                }

                return;
            });
        }
    },
});

